export default {
  order: 4,
  name: "Payslip",
  icon: "mdi-receipt",
  to: "/payslip",
  hasSubs: 0,
  enabled: true,
};
